import { call } from 'redux-saga/effects';
import { signalingPollEnded } from 'features/polls/actions';
import { closeRequestVoteNotificationSaga } from 'features/polls/sagas/closeRequestVoteNotificationSaga';

export function* onPollEndedSaga(action: ReturnType<typeof signalingPollEnded>) {
  yield call(closeRequestVoteNotificationSaga, action.payload.id);
}
